class PriceRangeSlider extends HTMLElement {
  constructor() {
    super();

    this.rangeMin = Number(this.dataset.min || 0);
    this.rangeMax = Number(this.dataset.max || 100);

    this.thumbMin = this.querySelector('[data-thumb="min"]');
    this.thumbMax = this.querySelector('[data-thumb="max"]');
    this.inputMin = this.querySelector('[data-input="min"]');
    this.inputMax = this.querySelector('[data-input="max"]');
    this.fill = this.querySelector('[data-fill]');

    if (!this.thumbMin || !this.thumbMax || !this.inputMin || !this.inputMax) return;

    this.onThumbInput = this.onThumbInput.bind(this);
    this.onThumbChange = this.onThumbChange.bind(this);
    this.onTextChange = this.onTextChange.bind(this);
    this.onTextKeydown = this.onTextKeydown.bind(this);

    this.thumbMin.addEventListener('input', this.onThumbInput);
    this.thumbMax.addEventListener('input', this.onThumbInput);
    this.thumbMin.addEventListener('change', this.onThumbChange);
    this.thumbMax.addEventListener('change', this.onThumbChange);

    this.inputMin.addEventListener('change', this.onTextChange);
    this.inputMax.addEventListener('change', this.onTextChange);
    this.inputMin.addEventListener('keydown', this.onTextKeydown);
    this.inputMax.addEventListener('keydown', this.onTextKeydown);

    this.syncFromText({ silent: true });
  }

  parsedMinText() {
    const v = this.inputMin.value.trim();
    return v === '' ? this.rangeMin : this.clamp(Number(v));
  }

  parsedMaxText() {
    const v = this.inputMax.value.trim();
    return v === '' ? this.rangeMax : this.clamp(Number(v));
  }

  clamp(n) {
    if (Number.isNaN(n)) return this.rangeMin;
    return Math.max(this.rangeMin, Math.min(this.rangeMax, n));
  }

  syncFromText({ silent = false } = {}) {
    let lo = this.parsedMinText();
    let hi = this.parsedMaxText();
    if (lo > hi) [lo, hi] = [hi, lo];
    this.thumbMin.value = String(lo);
    this.thumbMax.value = String(hi);
    this.updateFill(lo, hi);
    if (!silent) this.writeText(lo, hi);
  }

  onThumbInput() {
    let lo = Number(this.thumbMin.value);
    let hi = Number(this.thumbMax.value);
    if (lo > hi) {
      // Whichever thumb is being dragged should not push past the other.
      if (document.activeElement === this.thumbMin) {
        lo = hi;
        this.thumbMin.value = String(lo);
      } else {
        hi = lo;
        this.thumbMax.value = String(hi);
      }
    }
    this.updateFill(lo, hi);
    this.writeText(lo, hi, { silent: true });
  }

  onThumbChange() {
    const lo = Number(this.thumbMin.value);
    const hi = Number(this.thumbMax.value);
    this.writeText(lo, hi);
  }

  onTextChange() {
    this.syncFromText();
  }

  onTextKeydown(event) {
    if (event.metaKey) return;
    const pattern = /[0-9]|\.|,|Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape|Home|End/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  writeText(lo, hi, { silent = false } = {}) {
    const minText = lo <= this.rangeMin ? '' : String(lo);
    const maxText = hi >= this.rangeMax ? '' : String(hi);
    const minChanged = this.inputMin.value !== minText;
    const maxChanged = this.inputMax.value !== maxText;
    this.inputMin.value = minText;
    this.inputMax.value = maxText;
    if (silent) return;
    if (minChanged) this.inputMin.dispatchEvent(new Event('input', { bubbles: true }));
    if (maxChanged) this.inputMax.dispatchEvent(new Event('input', { bubbles: true }));
  }

  updateFill(lo, hi) {
    if (!this.fill) return;
    const range = this.rangeMax - this.rangeMin;
    if (range <= 0) return;
    const leftPct = ((lo - this.rangeMin) / range) * 100;
    const rightPct = ((hi - this.rangeMin) / range) * 100;
    this.fill.style.left = leftPct + '%';
    this.fill.style.right = (100 - rightPct) + '%';
  }
}

customElements.define('price-range-slider', PriceRangeSlider);
